import http from '../utils/http'
import store from '../store'
// import router from '../router'
// console.log('action', router.history.current)

/** post **/
export function postAction (url, parameter, type, appKey = store.state.appKey, token = store.state.token) {
  return http.post(url, parameter, type, appKey, token)
}

/** put **/
export function putAction (url, parameter, type, appKey = store.state.appKey, token = store.state.token) {
  return http.put(url, parameter, type, appKey, token)
}

/** get **/
export function getAction (url, parameter, appKey = store.state.appKey, token = store.state.token) {
  return http.get(url, parameter, appKey, token)
}

/** deleteAction **/
export function deleteAction (url, parameter, appKey = store.state.appKey, token = store.state.token) {
  return http.del(url, parameter, appKey, token)
}



// WEBPACK FOOTER //
// ./src/api/action.js